// Wrapper
import { rootWrapper } from './Wrapper';

export const wrapRootElement = rootWrapper;
